import { render } from "./PrintNotes.vue?vue&type=template&id=af5f78f2&scoped=true"
import script from "./PrintNotes.vue?vue&type=script&lang=js"
export * from "./PrintNotes.vue?vue&type=script&lang=js"

import "./PrintNotes.vue?vue&type=style&index=0&id=af5f78f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5f78f2"]])

export default __exports__